import React, { Dispatch } from 'react'
import { AuthenticationData } from '../definition'

export interface ContextData {
  authenticationData?: AuthenticationData
  isEmptyNotification?: boolean
}

export interface IAppContext {
  contextData: ContextData
  setContextData: Dispatch<React.SetStateAction<ContextData>>
}

export const defaultContext: ContextData = {
  isEmptyNotification: true
}

export const ApplicationContext = React.createContext<IAppContext>({
  contextData: defaultContext,
  setContextData: () => {}
})
